import { PayloadAction } from '@reduxjs/toolkit';
import {
  AccountCreatedType,
  AccountListResponse,
  ErrorType,
  UserListResponse,
  UserObj,
  UserState,
  ForgotPasswordSuccess,
  fedexCarrierPayload,
  CarrierSettingsList,
  dhlCarrierPayload,
  aramexCarrierPayload,
  stageCarrierPayload,
  bluedartCarrierPayload,
  universalCarrierPayload,
  thinkLogisticsCarrierPayload,
  iThinkLogisticsDomesticCarrierPayload,
  linexCarrierPayload,
  delhiveryCarrierPayload,
  nandanCarrierPayload,
  emiratesCarrierPayload,
  trackonCarrierPayload,
  dpdukCarrierPayload,
} from './Type';
import { SuccessPayload } from '../../../types';
import {
  fedexInitialValues,
  dhlInitialValues,
  aramexIntialValues,
  stageIntialValues,
  universalInitialValues,
  bluedartInitialValues,
  thinkLogisticsInitialValues,
  iThinkLogisticsDomesticInitialValues,
  linexInitialValues,
  delhiveryInitialValues,
  nandanInitialValues,
  emiratesInitialValues,
  trackonInitialValues,
  dpdukInitialValues,
} from '../../../pages/CreateAccount/CarrierAccess/constant';

function handlePending(state: UserState) {
  state.loading = true;
  state.success = '';
  state.error = {
    msg: '',
    errorDetails: '',
    isError: false,
  };
}

function handleRejected(state: UserState, action: PayloadAction<ErrorType | undefined>) {
  state.loading = false;
  state.error = { msg: action.payload?.msg || action.payload?.errorDetails || 'Error', isError: true };
}

function getUserListFulfilled(state: UserState, action: { payload: UserListResponse }) {
  const { lists, currentPage, perPage, totalCount } = action.payload;
  state.data.list = lists;
  state.data.totalCount = totalCount;
  state.data.currentPage = currentPage;
  state.data.perPage = perPage;
  state.loading = false;
}

function getAccountListFulfilled(state: UserState, action: { payload: AccountListResponse }) {
  state.accountList = action.payload.data;
  state.loading = false;
}

function createAccountFullfilled(state: UserState, action: PayloadAction<AccountCreatedType>) {
  console.log('createAccountFullfilled action.payload', action.payload);
  state.accountCreated = action.payload;
  state.loading = false;
}
function createAccountRejected(state: UserState, action: { payload: ErrorType | undefined }) {
  state.accountCreated = {
    isInserted: false,
    isEmailSent: false,
    isError: true,
    msg: action.payload?.msg || action.payload?.errorDetails || 'Unable to create user account.',
  };
  state.loading = false;
}

function resendInviteFulfilled(state: UserState, action: PayloadAction<AccountCreatedType>) {
  state.loading = false;
  state.accountCreated = action.payload;
}
function viewContractFulfilled(state: UserState, action: { payload: SuccessPayload }) {
  state.loading = false;
  state.success = action.payload.msg;
}
function deactivateUserAccountFulfilled(state: UserState, action: { payload: SuccessPayload }) {
  state.loading = false;
  state.success = action.payload.msg;
}
function suspendUserAccountFulfilled(state: UserState, action: { payload: SuccessPayload }) {
  state.loading = false;
  state.success = action.payload.msg;
}
function restoreUserAccountFulfilled(state: UserState, action: { payload: SuccessPayload }) {
  state.loading = false;
  state.success = action.payload.msg;
}
function getUserByIdFullfilled(state: UserState, action: { payload: UserObj }) {
  state.userDataById = action.payload;
  state.carrierSetting.fedex._accountId = action.payload._accountId?._id || '';
  state.carrierSetting.fedex.accountNumber = action.payload._accountId?.accountNumber || '';
  state.carrierSetting.dhl._accountId = action.payload._accountId?._id || '';
  state.carrierSetting.dhl.accountNumber = action.payload._accountId?.accountNumber || '';
  state.carrierSetting.aramex._accountId = action.payload._accountId?._id || '';
  state.carrierSetting.aramex.accountNumber = action.payload._accountId?.accountNumber || '';
  state.carrierSetting.stage.accountNumber = action.payload._accountId?.accountNumber || '';
  state.carrierSetting.stage._accountId = action.payload._accountId?._id || '';
  state.carrierSetting.bluedart._accountId = action.payload._accountId?._id || '';
  state.carrierSetting.bluedart.accountNumber = action.payload._accountId?.accountNumber || '';
  state.carrierSetting.universal._accountId = action.payload._accountId?._id || '';
  state.carrierSetting.universal.accountNumber = action.payload._accountId?.accountNumber || '';
  state.carrierSetting.ithinklogistics._accountId = action.payload._accountId?._id || '';
  state.carrierSetting.ithinklogistics.accountNumber = action.payload._accountId?.accountNumber || '';
  state.carrierSetting.ithink_logistics_domestic._accountId = action.payload._accountId?._id || '';
  state.carrierSetting.ithink_logistics_domestic.accountNumber = action.payload._accountId?.accountNumber || '';
  state.carrierSetting.linex._accountId = action.payload._accountId?._id || '';
  state.carrierSetting.linex.accountNumber = action.payload._accountId?.accountNumber || '';
  state.carrierSetting.delhivery._accountId = action.payload._accountId?._id || '';
  state.carrierSetting.delhivery.accountNumber = action.payload._accountId?.accountNumber || '';
  state.carrierSetting.emirates_skycargo._accountId = action.payload._accountId?._id || '';
  state.carrierSetting.emirates_skycargo.accountNumber = action.payload._accountId?.accountNumber || '';
  state.carrierSetting.trackon._accountId = action.payload._accountId?._id || '';
  state.carrierSetting.trackon.accountNumber = action.payload._accountId?.accountNumber || '';
  state.carrierSetting.dpduk._accountId = action.payload._accountId?._id || '';
  state.carrierSetting.dpduk.accountNumber = action.payload._accountId?.accountNumber || '';
  state.carrierSetting.shree_nandan_courier_limited._accountId = action.payload._accountId?._id || '';
  state.carrierSetting.shree_nandan_courier_limited.accountNumber = action.payload._accountId?.accountNumber || '';
  state.loading = false;
}

function updateAccountFullfilled(state: UserState, action: { payload: UserObj }) {
  state.userDataById = action.payload;
  state.isUserUpdated = true;
  state.loading = false;
}

function forgotPasswordFullfilled(state: UserState, action: { payload: ForgotPasswordSuccess }) {
  state.resetPassword = action.payload;
  state.loading = false;
}

function confirmForgotPasswordFullfilled(state: UserState, action: { payload: { msg: string } }) {
  state.resetPassword = action.payload;
  state.loading = false;
}

function isFedexPayload(payload: any): payload is fedexCarrierPayload {
  // return 'accountNumber' in payload && 'csp' in payload;
  return 'packagingType' in payload && 'csp' in payload;
}

function isDhlPayload(payload: any): payload is dhlCarrierPayload {
  return 'paymentMode' in payload && 'ShipperType' in payload && 'ShipmentType' in payload && 'csp' in payload;
}
function isAramexPayload(payload: any): payload is aramexCarrierPayload {
  return 'paymentType' in payload && 'csp' in payload;
}
function isUniversalPayload(payload: any): payload is universalCarrierPayload {
  return 'productCode' in payload && 'csp' in payload;
}
function isThinkLogisticsPayload(payload: any): payload is thinkLogisticsCarrierPayload {
  return 'is_having_battery' in payload && 'csp' in payload;
}

function isIThinkLogisticsDomesticPayload(payload: any): payload is iThinkLogisticsDomesticCarrierPayload {
  return 'pickup_address_id' in payload && 'order_type' in payload && 'logistics' in payload && 'csp' in payload;
}

function isEmiratesPayload(payload: any): payload is emiratesCarrierPayload {
  return 'paymentMode' in payload && 'serviceType' in payload && 'shipmentPurpose' in payload && 'csp' in payload;
}

function isStagePayload(payload: any): payload is stageCarrierPayload {
  return 'csp' in payload;
}
function isBluedartPayload(payload: any): payload is bluedartCarrierPayload {
  return 'subProductCode' in payload && 'csp' in payload;
}
function isLinexPayload(payload: any): payload is linexCarrierPayload {
  return 'PaymentType' in payload && 'dutyType' in payload && 'declareCurrency' in payload && 'csp' in payload;
}
function isDelhiveryPayload(payload: any): payload is delhiveryCarrierPayload {
  return 'payment_mode' in payload && 'pickup_location' in payload && 'csp' in payload;
}
function isTrackonPayload(payload: any): payload is trackonCarrierPayload {
  return 'DocType' in payload && 'TypeOfService' in payload && 'csp' in payload;
}
function isDpdukPayload(payload: any): payload is dpdukCarrierPayload {
  return 'exportReason' in payload && 'termsOfDelivery' in payload && 'invoiceType' in payload;
}
function isNandanPayload(payload: any): payload is nandanCarrierPayload {
  return 'product_id' in payload && 'pickup_pincode' in payload && 'csp' in payload;
}

function getCarrierSettingsFullfilled(
  state: UserState,
  action: {
    payload:
      | SuccessPayload<fedexCarrierPayload>
      | SuccessPayload<dhlCarrierPayload>
      | SuccessPayload<aramexCarrierPayload>
      | SuccessPayload<stageCarrierPayload>
      | SuccessPayload<universalCarrierPayload>
      | SuccessPayload<linexCarrierPayload>
      | SuccessPayload<delhiveryCarrierPayload>
      | SuccessPayload<emiratesCarrierPayload>
      | SuccessPayload<trackonCarrierPayload>
      | SuccessPayload<bluedartCarrierPayload>
      | SuccessPayload<dpdukCarrierPayload>
      | SuccessPayload<nandanCarrierPayload>;
  },
) {
  state.loading = false;
  if (action.payload.data && isFedexPayload(action.payload.data)) {
    const carrierType = action.payload.data.csp as keyof typeof state.carrierSetting;
    state.carrierSetting.fedex = {
      ...state.carrierSetting[carrierType],
      ...action.payload.data,
    };
  } else if (action.payload.data && isDhlPayload(action.payload.data)) {
    const carrierType = action.payload.data.csp as keyof typeof state.carrierSetting;
    state.carrierSetting.dhl = {
      ...state.carrierSetting[carrierType],
      ...action.payload.data,
    };
  } else if (action.payload.data && isAramexPayload(action.payload.data)) {
    const carrierType = action.payload.data.csp as keyof typeof state.carrierSetting;
    state.carrierSetting.aramex = {
      ...state.carrierSetting[carrierType],
      ...action.payload.data,
    };
  } else if (action.payload.data && isUniversalPayload(action.payload.data)) {
    const carrierType = action.payload.data.csp as keyof typeof state.carrierSetting;
    state.carrierSetting.universal = {
      ...state.carrierSetting[carrierType],
      ...action.payload.data,
    };
  } else if (action.payload.data && isThinkLogisticsPayload(action.payload.data)) {
    const carrierType = action.payload.data.csp as keyof typeof state.carrierSetting;
    state.carrierSetting.ithinklogistics = {
      ...state.carrierSetting[carrierType],
      ...action.payload.data,
    };
  } else if (action.payload.data && isIThinkLogisticsDomesticPayload(action.payload.data)) {
    const carrierType = action.payload.data.csp as keyof typeof state.carrierSetting;
    state.carrierSetting.ithink_logistics_domestic = {
      ...state.carrierSetting[carrierType],
      ...action.payload.data,
    };
  } else if (action.payload.data && isDelhiveryPayload(action.payload.data)) {
    const carrierType = action.payload.data.csp as keyof typeof state.carrierSetting;
    state.carrierSetting.delhivery = {
      ...state.carrierSetting[carrierType],
      ...action.payload.data,
    };
  } else if (action.payload.data && isLinexPayload(action.payload.data)) {
    const carrierType = action.payload.data.csp as keyof typeof state.carrierSetting;
    state.carrierSetting.linex = {
      ...state.carrierSetting[carrierType],
      ...action.payload.data,
    };
  } else if (action.payload.data && isEmiratesPayload(action.payload.data)) {
    const carrierType = action.payload.data.csp as keyof typeof state.carrierSetting;
    state.carrierSetting.emirates_skycargo = {
      ...state.carrierSetting[carrierType],
      ...action.payload.data,
    };
  } else if (action.payload.data && isTrackonPayload(action.payload.data)) {
    const carrierType = action.payload.data.csp as keyof typeof state.carrierSetting;
    state.carrierSetting.trackon = {
      ...state.carrierSetting[carrierType],
      ...action.payload.data,
    };
  } else if (action.payload.data && isDpdukPayload(action.payload.data)) {
    const carrierType = action.payload.data.csp as keyof typeof state.carrierSetting;
    state.carrierSetting.dpduk = {
      ...state.carrierSetting[carrierType],
      ...action.payload.data,
    };
  } else if (action.payload.data && isNandanPayload(action.payload.data)) {
    const carrierType = action.payload.data.csp as keyof typeof state.carrierSetting;
    state.carrierSetting.shree_nandan_courier_limited = {
      ...state.carrierSetting[carrierType],
      ...action.payload.data,
    };
  } else if (action.payload.data && isBluedartPayload(action.payload.data)) {
    const carrierType = action.payload.data.csp as keyof typeof state.carrierSetting;
    state.carrierSetting.bluedart = {
      ...state.carrierSetting[carrierType],
      ...action.payload.data,
    };
  } else if (action.payload.data && isStagePayload(action.payload.data)) {
    const carrierType = action.payload.data.csp as keyof typeof state.carrierSetting;
    state.carrierSetting.stage = {
      ...state.carrierSetting[carrierType],
      ...action.payload.data,
    };
  } else if (action.payload.data === null) {
    // state.carrierSetting.fedex = action.payload.data;
    state.carrierSetting.fedex = { ...fedexInitialValues, _accountId: '', accountNumber: '' };
    state.carrierSetting.dhl = { ...dhlInitialValues, _accountId: '', accountNumber: '' };
    state.carrierSetting.aramex = { ...aramexIntialValues, _accountId: '', accountNumber: '' };
    state.carrierSetting.stage = { ...stageIntialValues, _accountId: '', accountNumber: '' };
    state.carrierSetting.universal = { ...universalInitialValues, _accountId: '', accountNumber: '' };
    state.carrierSetting.ithinklogistics = { ...thinkLogisticsInitialValues, _accountId: '', accountNumber: '' };
    state.carrierSetting.ithink_logistics_domestic = {
      ...iThinkLogisticsDomesticInitialValues,
      _accountId: '',
      accountNumber: '',
    };
    state.carrierSetting.linex = {
      ...linexInitialValues,
      _accountId: '',
      accountNumber: '',
    };
    state.carrierSetting.delhivery = {
      ...delhiveryInitialValues,
      _accountId: '',
      accountNumber: '',
    };
    state.carrierSetting.shree_nandan_courier_limited = {
      ...nandanInitialValues,
      _accountId: '',
      accountNumber: '',
    };
    state.carrierSetting.trackon = {
      ...trackonInitialValues,
      _accountId: '',
      accountNumber: '',
    };
    state.carrierSetting.emirates_skycargo = {
      ...emiratesInitialValues,
      _accountId: '',
      accountNumber: '',
    };
    state.carrierSetting.dpduk = {
      ...dpdukInitialValues,
      _accountId: '',
      accountNumber: '',
    };
    state.carrierSetting.bluedart = { ...bluedartInitialValues, _accountId: '', accountNumber: '' };
  }

  state.loading = false;
}

function getCarrierSettingsListFullfilled(state: UserState, action: { payload: SuccessPayload<CarrierSettingsList> }) {
  state.carrierSettingList = action.payload.data || [];
  state.loading = false;
}

// function deactivateAccountFulfilled() {}
// function suspendAccountFulfilled() {}
// function restoreAccountFulfilled() {}

export {
  getUserListFulfilled,
  handlePending,
  handleRejected,
  resendInviteFulfilled,
  viewContractFulfilled,
  deactivateUserAccountFulfilled,
  suspendUserAccountFulfilled,
  restoreUserAccountFulfilled,
  getAccountListFulfilled,
  createAccountFullfilled,
  createAccountRejected,
  getUserByIdFullfilled,
  updateAccountFullfilled,
  forgotPasswordFullfilled,
  confirmForgotPasswordFullfilled,
  getCarrierSettingsFullfilled,
  getCarrierSettingsListFullfilled,
};
